//// Application Packages
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { format } from 'date-fns'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    updateFormData,
    updateFormValidity,
    selectForms,
} from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import { Select, SelectItem, DatePicker, DatePickerInput } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const AdditionalRegisteredNursingExaminationLicenseHolderBackgroundForm =
    () => {
        //////// Hooks
        const dispatch = useDispatch()

        //////// State

        //////// Slices
        const settingsData = useSelector(selectSettings)
        const formsData = useSelector(selectForms)

        //// Slice Data
        const digital_name = settingsData?.['form']?.['digital_name']

        //////// Search Params

        //////// Methods

        // Re-Validate Data Submission
        const revalidation = async (event_name) => {
            // Update Validation State
            if (digital_name && event_name) {
                dispatch(
                    updateFormValidity({
                        digital_name: digital_name,
                        errors: {
                            [event_name]: false,
                            [event_name + 'ErrMsg']: '',
                        },
                    })
                )
            }
        }

        //////// Functional Methods

        // Handle Data Of All Fields + DatePicker (ID)
        const handleData = (e, id) => {
            if (e?.target?.name && e?.target?.value) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [e.target.name]: e.target.value,
                        },
                    })
                )
                revalidation(e.target.name)
            } else if (e?.target?.name) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: { [e.target.name]: '' },
                    })
                )
                revalidation(e.target.name)
            } else if (e?.length > 0 && id) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [id]: format(new Date(e?.[0]), 'MM/dd/yyyy'),
                        },
                    })
                )
                revalidation(id)
            }
            //// Start Watson Assistant Journey

            //// End Watson Assistant Journey
        }

        //////// Memoization

        //////// Effects/Side Effects

        //////////////// Render & Return
        if (formsData?.[digital_name]?.values?.APP_LPN === 'Y') {
            return (
                <>
                    <Select
                        className="required"
                        defaultValue={
                            formsData?.[digital_name]?.values?.LIC_TYPE_LPN
                        }
                        value={formsData?.[digital_name]?.values?.LIC_TYPE_LPN}
                        helper=""
                        labelText="License Type:"
                        id="LIC_TYPE_LPN"
                        name="LIC_TYPE_LPN"
                        onChange={handleData}
                        invalid={
                            formsData?.[digital_name]?.errors?.LIC_TYPE_LPN
                        }
                        invalidText={
                            formsData?.[digital_name]?.errors
                                ?.LIC_TYPE_LPNErrMsg
                        }
                    >
                        <SelectItem text="Choose an option" value="" />
                        <SelectItem text="LPN" value="LPN" />
                        <SelectItem text="RN" value="RN" />
                    </Select>

                    <DatePicker
                        dateFormat="m/d/Y"
                        datePickerType="single"
                        onChange={(e) => handleData(e, 'APP_LPN_DTE')}
                        onClose={(e) => handleData(e, 'APP_LPN_DTE')}
                        value={formsData?.[digital_name]?.values?.APP_LPN_DTE}
                    >
                        <DatePickerInput
                            className="required"
                            labelText="License Date:"
                            id="APP_LPN_DTE"
                            name="APP_LPN_DTE"
                            placeholder="MM/DD/YYYY"
                            type="text"
                            invalid={
                                formsData?.[digital_name]?.errors?.APP_LPN_DTE
                            }
                            invalidText={
                                formsData?.[digital_name]?.errors
                                    ?.APP_LPN_DTEErrMsg
                            }
                        />
                    </DatePicker>
                </>
            )
        }
    }

export default AdditionalRegisteredNursingExaminationLicenseHolderBackgroundForm
